var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.17 64.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffffff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.96,64.17c-1.89,0-3.54-1.3-3.95-3.15L.1,48.46c-.43-1.92.56-3.88,2.36-4.67l13.54-5.8c1.66-.7,3.59-.23,4.74,1.17l5.41,6.6c8.5-4.24,15.4-11.13,19.64-19.63l-6.62-5.4c-1.4-1.15-1.88-3.08-1.17-4.74l5.8-13.53c.78-1.8,2.74-2.79,4.65-2.36l12.56,2.9c1.85.42,3.16,2.07,3.15,3.97-.04,31.57-25.63,57.16-57.2,57.2h-.01M17.59,40c-.23,0-.46.05-.67.14l-13.53,5.8c-.77.34-1.2,1.18-1.01,2l2.9,12.56c.18.79.88,1.34,1.69,1.34h0c30.29-.03,54.83-24.58,54.87-54.86,0-.81-.55-1.52-1.34-1.7l-12.56-2.9c-.82-.19-1.66.24-1.99,1.01l-5.79,13.51c-.3.71-.1,1.53.5,2.02l8.03,6.56-.39.82c-4.55,9.64-12.32,17.41-21.96,21.96l-.82.39-6.57-8.02c-.33-.4-.83-.64-1.35-.64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact);
export default __webpack_public_path__ + "static/media/icon-contact.c68d3f0f.svg";
export { ForwardRef as ReactComponent };